import { Minus, Maximize2, Minimize2, X } from "lucide-react";

interface ToolWindowFrameProps {
  title: string;
  isMaximized?: boolean;
  onClose?: () => void;
  onMinimize?: () => void;
  onMaximize?: () => void;
  draggable?: boolean;
  children: React.ReactNode;
}

export default function ToolWindowFrame({
  title,
  isMaximized,
  onClose,
  onMinimize,
  onMaximize,
  children,
}: ToolWindowFrameProps) {
  return (
    <div className="h-full w-full flex flex-col bg-window border-2 border-primary/50 rounded-xl shadow-2xl shadow-primary/20 overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-primary/20 to-primary/10 border-b border-border">
        <h2 className="text-sm font-semibold text-foreground select-none">
          {title}
        </h2>
        <div className="flex items-center gap-1">
          {onMaximize && (
            <button
              onClick={onMaximize}
              className="p-1.5 rounded hover:bg-window/80 transition-colors"
            >
              {isMaximized ? (
                <Minimize2 className="w-4 h-4" />
              ) : (
                <Maximize2 className="w-4 h-4" />
              )}
            </button>
          )}
          {onMinimize && (
            <button
              onClick={onMinimize}
              className="p-1.5 rounded hover:bg-window/80 transition-colors"
            >
              <Minus className="w-4 h-4" />
            </button>
          )}
          {onClose && (
            <button
              onClick={onClose}
              className="p-1.5 rounded hover:bg-red-500/20 text-red-500 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto p-4">
        {children}
      </div>
    </div>
  );
}
